import { render, staticRenderFns } from "./postItem.vue?vue&type=template&id=6df5efa8&scoped=true"
import script from "./postItem.vue?vue&type=script&lang=js"
export * from "./postItem.vue?vue&type=script&lang=js"
import style0 from "./postItem.vue?vue&type=style&index=0&id=6df5efa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df5efa8",
  null
  
)

export default component.exports